import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CyberCareContainerComponent } from './cyber-care-container/cyber-care-container.component';
import { CyberCareDetailsAllowedGuard } from '../guards/cyber-care-details-allowed.guard';
import { MyProximusAuthenticationCheckGuard } from '../guards/myproximus-authentication-check.guard';

const routes: Routes = [
  {
    path: 'details/cyber-care',
    component: CyberCareContainerComponent,
    canActivate: [
      MyProximusAuthenticationCheckGuard,
      CyberCareDetailsAllowedGuard,
    ],
    data: {
      analytics: {
        page: {
          name: 'myproducts cyber care',
          id: 'myproducts cyber care',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'cyber care',
          },
        },
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CyberCareRoutingModule {}
